import { Link } from "react-router-dom";
import { Mail, ShieldCheck, Swords } from "lucide-react";
import { CONTACT_EMAIL } from "../data/legal";
import { openCookieSettings } from "./CookieConsent";

const Col = ({ title, children }) => (
  <div>
    <div className="text-[11px] label-eyebrow text-[#0F172A]">{title}</div>
    <ul className="mt-3 space-y-2 text-sm text-[#64748B]">{children}</ul>
  </div>
);

// Professional site footer: brand, legal links, contact and the virtual-currency notice.
const SiteFooter = ({ className = "" }) => (
  <footer data-testid="site-footer" className={`relative z-10 border-t border-[#E2E8F0] bg-white text-[#64748B] ${className}`}>
    <div className="max-w-6xl mx-auto px-5 lg:px-8 py-10 grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
      <div className="lg:col-span-2 max-w-sm">
        <div className="flex items-center gap-2 font-display font-extrabold uppercase text-lg text-[#0F172A]">
          <span className="w-7 h-7 rounded-md bg-[#10B981] flex items-center justify-center"><Swords className="w-4 h-4 text-[#0F172A]" strokeWidth={2.5} /></span>
          Footie Clash
        </div>
        <p className="text-sm mt-3 leading-relaxed">Draft your XI, take on Pep or wager a mate. A free football game for fans.</p>
        <p data-testid="virtual-money-note" className="text-xs mt-3 flex items-start gap-1.5"><ShieldCheck className="w-4 h-4 text-[#059669] shrink-0" /> Game balances, stakes and winnings are virtual £ with no cash value. Prize wheel vouchers are real prizes.</p>
      </div>
      <Col title="Legal">
        <li><Link data-testid="footer-privacy" to="/privacy" className="hover:text-[#0F172A]">Privacy Policy</Link></li>
        <li><Link data-testid="footer-terms" to="/terms" className="hover:text-[#0F172A]">Terms of Use</Link></li>
        <li><Link data-testid="footer-cookies" to="/cookies" className="hover:text-[#0F172A]">Cookie Policy</Link></li>
        <li><button data-testid="footer-cookie-settings" onClick={openCookieSettings} className="hover:text-[#0F172A]">Cookie settings</button></li>
      </Col>
      <Col title="Contact">
        <li><a data-testid="footer-email" href={`mailto:${CONTACT_EMAIL}`} className="inline-flex items-center gap-1.5 hover:text-[#0F172A]"><Mail className="w-4 h-4" /> {CONTACT_EMAIL}</a></li>
        <li className="text-xs leading-relaxed">We reply within 2 working days.</li>
      </Col>
    </div>
    <div className="border-t border-[#E2E8F0]">
      <div className="max-w-6xl mx-auto px-5 lg:px-8 py-4 flex flex-col sm:flex-row justify-between gap-2 text-xs">
        <span>© {new Date().getFullYear()} Footie Clash. All rights reserved.</span>
        <span>Independent fan-made game. Not affiliated with any club, league or player.</span>
      </div>
    </div>
  </footer>
);

export default SiteFooter;
